import { useState, useEffect } from 'react';
import { JobsiteService, JobsiteDetailResponse, JobsiteTradeResponse } from '../services/jobsite.service';
import { JobsiteFileResponse } from '../types/jobsite-details.types';

export const useJobsiteData = (id: string | undefined, showEditDialog: boolean) => {
    const [jobsiteData, setJobsiteData] = useState<JobsiteDetailResponse | null>(null);
    const [jobsiteTradeData, setJobsiteTradeData] = useState<JobsiteTradeResponse | null>(null);
    const [jobsiteFiles, setJobsiteFiles] = useState<JobsiteFileResponse[]>([]);
    const [addressId, setAddressId] = useState<string>('');

    const refreshJobsiteFiles = async () => {
        if (!id) return;
        try {
            const filesResponse = await JobsiteService.getJobsiteFiles(id);
            setJobsiteFiles(Array.isArray(filesResponse) ? filesResponse as JobsiteFileResponse[] : []);
        } catch (error) {
            console.error('Error refreshing jobsite files:', error);
        }
    };

    useEffect(() => {
        let isMounted = true;

        const fetchJobsiteDetails = async () => {
            if (!id) return;

            try {
                const addressResponse = await JobsiteService.getJobsiteAddress(id);
                if (isMounted && addressResponse && addressResponse.id) {
                    setAddressId(addressResponse.id);
                } else {
                    setAddressId('');
                }

                const filesResponse = await JobsiteService.getJobsiteFiles(id);
                if (isMounted && filesResponse) {
                    setJobsiteFiles(Array.isArray(filesResponse) ? filesResponse as JobsiteFileResponse[] : []);
                }

                const tradesResponse = await JobsiteService.getJobsiteTrades(id);
                const response = await JobsiteService.getJobsiteById(id);

                if (isMounted) {
                    setJobsiteData(response);
                    if (tradesResponse) {
                        setJobsiteTradeData(tradesResponse);
                    }
                }
            } catch (error) {
                console.error('Error fetching jobsite details:', error);
            }
        };

        fetchJobsiteDetails();

        return () => {
            isMounted = false;
        };
    }, [id, showEditDialog]);

    return {
        jobsiteData,
        setJobsiteData,
        jobsiteTradeData,
        setJobsiteTradeData,
        jobsiteFiles,
        setJobsiteFiles,
        addressId,
        setAddressId,
        refreshJobsiteFiles
    };
}; 